import {
  AccountManageTypes,
} from '../../types/account';
// 公共state
const state: AccountManageTypes = {
  isShowCreateForm: false,
  isShowOperateForm: false,
  actionName: '',
  accountIds: []
};
// 修改state
const mutations = {
  changeFormState(states: any, form: any) {
    states[form.name] = form.state;
  },
  changeActionName(states: any, actionName: string) {
    states.actionName = actionName;
  },
  addAccountIds(states: any, accountIds: string) {
    states.accountIds.push(accountIds);
  },
  initAccountIds(states: any, ) {
    states.accountIds = [];
  }
};
// 外部调用修改state
const actions = {
  setFormState(context: any, form: any) {
    context.commit('changeFormState', form);
  },
  setActionName(context: any, actionName: any) {
    context.commit('changeActionName', actionName);
  },
  addAccountIds(context: any, accountIds: string[]) {
    context.commit('addAccountIds', accountIds);
  },
  initAccountIds(context: any, ) {
    context.commit('initAccountIds');
  }
};
// 外部调用获取state
const getters = {
  getCreateFormState(states: any) {
    return states.isShowCreateForm;
  },
  getOperateFormState(states: any) {
    return states.isShowOperateForm;
  },
  getActionName(states: any) {
    return states.actionName;
  },
  getAccountIds(states: any) {
    return states.accountIds;
  }
};
export default {
  // 公共state
  state,
  // 修改state
  mutations,
  // 外部调用修改state
  actions,
  // 外部调用获取state
  getters
};
